export default {
  coffeeData: {
    windBreaker: "Mti wa Kuvunja Upepo",
    horticultureInfo: "Mti wa Kilimo cha bustani",
    shadeTree: "Mti wa Kivuli",
    coffeeVariety: "Aina ya Kahawa",
    coffeeSpecies: "Aina za Kahawa",
    coffeeCherryQuality: "Ubora wa Cherry ya Kahawa",
    processingBatchQuality: "Ubora wa Kundi la Usindikaji",
    processType: "Aina ya Mchakato",
    updateWindBreaker: "Sasisha Aina ya Mti wa WindBreaker",
    addWindBreaker: "Ongeza Aina Mpya ya Mti wa WindBreaker",
    updateHorticultureInfo: "Sasisha Aina ya Mti wa HorticultureInfo",
    addHorticultureInfo: "Ongeza Aina Mpya ya Miti ya HorticultureInfo",
    updateShadeTree: "Sasisha kivuliMti Aina ya Mti",
    addShadeTree: "Ongeza Kivuli Kipya Aina ya Mti",
    updateCoffeeVariety: "Sasisha aina ya mti wa kahawa",
    addCoffeeVariety: "Ongeza kahawa Mpya Aina ya Mti",
    deleteVarietyTitle: "Futa Aina",
    deleteVarietyMessage: "Je, una uhakika unataka kufuta Aina mbalimbali?",
    updateCoffeeSpecie: "Sasisha Aina ya Kahawa",
    deleteSpecieTitle: "Futa Aina",
    deleteSpecieMessage: "Je, una uhakika unataka kufuta Spishi?",
    addCoffeeSpecie: "Ongeza aina Mpya ya Kahawa",
    variety: "Tofauti",
    selectVariety: "Chagua Aina",
    deleteCoffeeRecord: "Je, una uhakika unataka kufuta rekodi?",
    deleteCoffeeData: "Futa Data ya Kahawa",
    topicRequired: "Chagua Mada inahitajika",
    coffeeAddSuccess: "Aina ya Kahawa imeongezwa kwa mafanikio.",
    treeTypeSuccess: "Aina ya mti imeongezwa kwa mafanikio.",
    treeTypeUpdateSuccess: "Aina ya mti imesasishwa.",
    coffeeVarietySuccess: "Aina ya kahawa imeongezwa kwa mafanikio.",
    coffeeSpecieSuccess: "Aina ya kahawa imesasishwa.",
    nameRequired: "Jina linahitajika",
    notFound: "Hakuna Data ya Kahawa ya Msimamizi Imepatikana",
  },
  cacaoData: {
    bags: "Mifuko",
    batchVisualIdentification: "Utambuzi wa Visual wa Kikundi",
    boxes: "Masanduku",
    cacao: "Kakao",
    cacaoOverview: "Muhtasari wa Kakao",
    cacaoSpecies: "Aina za Kakao",
    cacaoType: "Aina ya Kakao",
    cacaoVariety: "Aina ya Kakao",
    cacaoWeight: "Uzito wa Kakao",
    deleteCacaoData: "Futa Data ya Kakao",
    deliveryMethod: "Njia ya Uwasilishaji",
    fermentationPercentage: "Asilimia ya Uchachuaji",
    fermetationMethod: "Njia ya Uchachuaji",
    finalWeight: "Uzito wa Mwisho",
    initialWeight: "Uzito wa Awali",
    performance: "Utendaji",
    piles: "Rundo",
    productPricePerKg: "Bei kwa Kila KG",
    productType: "Aina ya Bidhaa",
    productWeight: "Uzito wa Bidhaa",
    registerFermentation: "Sajili Uchachuaji",
    selectPlantation: "Chagua Shamba",
    selectZone: "Chagua Eneo",
    totalPrice: "Jumla ya Bei",
  },
  memberDataSection: {
    import: "Ingiza",
    buyingStation: "Kituo cha Kununua",
    factory: "Kiwanda",
    factories: "Vianda",
    factoriesName: "Jina la Kiwanda",
    factoriesProdChart: "Kiwanda cha Ungaji wa Bidhaa",
    factoryInfo: "Maelezo ya Kiwanda",
    continue: "Endelea",
    farmerId: "Kitambulisho cha Mkulima",
    farmerName: "Jina la Mkulima",
    farmerAddress: "Anwani ya Mkulima",
    quality: "Ubora",
    quantity: "Kiasi",
    importAll: "Ingiza Zote",
    importSelected: "Uagizaji Umechaguliwa",
    selectCrop: "Chagua Mazao",
    fileLoaded: "Faili imepakiwa",
    incorrectHeaders: "Vijajuu visivyo sahihi",
    processingBatch: "Kundi la usindikaji",
    purchaseOrder: "Agizo la Ununuzi",
    startDate: "Tarehe ya Kuanza",
    endDate: "Tarehe ya mwisho",
    purchasingOrder: "Agizo la Ununuzi",
    totalCoffeeCherry: "Jumla ya Cherry ya Kahawa",
    airHumidity: "Unyevu wa Hewa",
    density: "Msongamano",
    temperature: "Halijoto",
    beanMoistureContent: "Maudhui ya Unyevu wa Maharage",
    processType: "Aina ya Mchakato",
    batchRating: "Chagua Ukadiriaji wa Kundi",
    purchaseDate: "Tarehe ya Kununua",
    selectFarmer: "Chagua Mkulima",
    selectFarm: "Chagua Shamba",
    selectPlantation: "Chagua Upandaji miti",
    coffeeVariety: "Aina ya Kahawa",
    coffeeSpecies: "Aina za Kahawa",
    coffeeCherryQuantity: "Kiasi cha Cherry ya Kahawa",
    coffeeCherryQuality: "Ubora wa Cherry ya Kahawa",
    coffeeType: "Aina ya Kahawa",
    pricePerKg: "Bei Kwa Kg",
    processingDone: "Usindikaji Umekamilika",
    processedCoffeeOut: "Kahawa Iliyochakatwa",
    farmer: "Mkulima",
    farm: "Shamba",
    plantation: "Upandaji miti",
    farmers: "Wakulima",
    farmLimitUsed: "Kikomo cha Kilimo Kimetumika",
    phoneNumber: "Nambari ya simu",
    farmSize: "Ukubwa wa Shamba",
    farmLocation: "Shamba/Mahali",
    date: "Tarehe",
    status: "Hali",
    noFarmers: "Hakuna Wakulima Waliopatikana",
    approveReject: "Idhinisha/Kataa",
    farms: "Mashamba",
    crops: "Mazao",
    equipment: "Vifaa",
    noFarms: "Hakuna Mashamba Yaliyopatikana",
    views: "Tazama",
    selectStatus: "Chagua Hali",
    approved: "Imeidhinishwa",
    rejected: "Imekataliwa",
    reject: "Kataa",
    approve: "Idhinisha",
    cancel: "Ghairi",
    add: "Ongeza",
    describeYourReason: "Eleza sababu yako hapa",
    userInformation: "Taarifa za Mtumiaji",
    userFarmRequest: "Ombi la Shamba la Mtumiaji",
    userFarmInformation: "Taarifa za Shamba la Watumiaji",
    activity: "Shughuli",
    activityType: "Aina ya Shughuli",
    farmZone: "Eneo la Shamba",
    farmerView: "Mtazamo wa Mkulima",
    cropType: "Aina ya Mazao",
    cropVarity: "Tofauti ya Mazao",
    area: "Eneo",
    cost: "Gharama",
    geofence: "Geofence",
    map_views: "Mwonekano wa Ramani",
    viewAllFarms: "Tazama Mashamba Yote",
    farmersDetails: "Maelezo ya Mkulima",
    download: "Pakua",
    pOrder: {
      addNew: "Ongeza Mpya",
      viewAll: "Ona Zote",
      selectDate: "Chagua tarehe",
      makeSelection: "Fanya chaguo",
      coffeeType: "Aina ya kahawa",
      enterPrice: "Ingiza bei",
      reqPurchaseDate: "Tarehe ya ununuzi inahitajika",
      reqFarmer: "Mkulima anahitajika",
      reqCoffeeQnty: "Kiasi cha Kahawa ya Cherry kinahitajika",
      reqPrice: "Bei kwa Kilo kinahitajika",
      grandTotal: "JUMLA KUBWA",
      selectDateRange: "Chagua Kipindi cha Tarehe",
      import: "Import",
      purchaseId: "Nunua Idadi",
      purchaseDate: "Tarehe ya Ununuzi",
      farmerName: "Jina la Mkulima",
      quality: "Ubora",
      quantity: "Kiasi",
      pricePerKg: "Bei kwa Kilo",
      selectBuyingStation: "Chagua kituo cha ununuzi",
      searchUser: "tafuta mtumiaji",
    },
    dateOfEntry: "Tarehe ya Kuingia",
    farmActivities: "Shughuli za Shamba",
    farmActivity: "Shughuli ya Shamba",
    farmDetails: "Maelezo ya Shamba",
    farmID: "Kitambulisho cha Shamba",
    farmInformation: "Taarifa za Shamba",
    goalType: "Aina ya Lengo",
    locationAddress: "Anwani ya Mahali",
    ownershipType: "Aina ya Umiliki",
    selectFarmZone: "Chagua Eneo/Shamba",
    showOnMap: "Onyesha kwenye Ramani",
    totalCost: "Gharama Jumla",
    totalFarmArea: "Eneo Jumla la Shamba",
    totalFarmsRegistered: "Jumla ya Mashamba Yalisajiliwa",
    totalSize: "Ukubwa Jumla",
    totalZone: "Jumla ya Eneo",
    zone: "Eneo",
    zones: "Maeneo",
  
    // Buying Station specific translations
    buyingStations: "Vituo vya Ununuzi",
    registerBuyingStation: "Sajili Kituo cha Ununuzi",
    registerFactory: "Sajili Kiwanda",
    loadingFactory: "Inapakia Kiwanda...",
    loadingBuyingStation: "Inapakia Kituo cha Ununuzi...",
    searchBuyingStation: "Tafuta Kituo cha Ununuzi",
    searchFactory: "Tafuta Kiwanda",
    nameAndId: "Jina / Kitambulisho",
    email: "Barua pepe",
    mobileNumber: "Nambari ya Simu",
    role: "Jukumu",
    actions: "Vitendo",
    view: "Tazama",
    edit: "Hariri",
    activate: "Wezesha",
    deactivate: "Zima",
    operator: "Mchezaji",
    supplier: "Mtoa Huduma",
    active: "Imewezeshwa",
    deactivated: "Imezimwa",
    activatedSuccessfully: "Kituo cha ununuzi kimewezeshwa kwa mafanikio",
    deactivatedSuccessfully: "Kituo cha ununuzi kimezimwa kwa mafanikio",
  
    factoryActivatedSuccessfully: "Kiwanda kimewezeshwa kwa mafanikio",
    factoryDeactivatedSuccessfully: "Kiwanda kimezimwa kwa mafanikio",
    factoryRegisteredSuccessfully: "Kiwanda kimesajiliwa kwa mafanikio",
    
    // Buying Station Details specific translations
    userDetails: "Maelezo ya Mtumiaji",
    name: "Jina",
    provinceState: "Mkoa/Jimbo",
    villageCityTown: "Kijiji/Mji/Mji mdogo",
    country: "Nchi",
    associatedFarms: "Mashamba Yenye Uhusiano",
    back: "Rudi",
    addPurchaseOrder: "Ongeza Agizo la Ununuzi",
    search: "Tafuta",
    orderId: "Kitambulisho cha Agizo",
    farmFarmer: "Shamba / Mkulima",
    coffeeSpeciesVariety: "Aina / Tofauti ya Kahawa",
    quantityPrice: "Kiasi / Bei",
    delete: "Futa",
    
    // Processing Batch specific translations
    addProcessingBatch: "Ongeza Kundi la Usindikaji",
    batchId: "Kitambulisho cha Kundi",
    lots: "Vipande",
    greenCoffeeOut: "Kahawa Ijani Imetoka",
    startEndDate: "Tarehe ya Kuanza / Tarehe ya Mwisho",
    
    // Associated Farms specific translations
    addFarm: "Ongeza Shamba",
    farmNameAndId: "Jina la Shamba & Kitambulisho",
    addressOfProduction: "Anwani ya Uzalishaji",
    areaHa: "Eneo (ha)",
    type: "Aina",
    eudrDeforestationStatus: "Hali ya Ukatili wa Misitu ya EUDR",
    eudrDeforestationStatusTT: "Hali ya Tathmini ya Hatari ya Ukatili wa Misitu ya EUDR",
    zeroNegligibleProbability: "Uwezekano wa Sifuri / Kidogo",
    assessments: "Tathmini",
    riskAssessment: "Tathmini ya Hatari",
    compliant: "Inalingana",
    nonCompliant: "Hailingani",
    pending: "Inasubiri",
    dateOfSubmission: "Tarehe ya Uwasilishaji",
    dateOfExpiry: "Tarehe ya Mwisho wa Matumizi",
    
    confirmDialog: {
      delete: {
        title: "Futa Kituo cha Ununuzi",
        message: "Je, una uhakika unataka kufuta kituo hiki cha ununuzi?",
        confirmBtn: "Futa",
      }
    },
    
    registerNewFactory: "Sajili Kiwanda Kipya",
    selectHowYouWantToProceed: "Chagua Njia Unavyotaka Kuendelea",
    single: "Moja",
    multiple: "Nyingi",
    user: "Mtumiaji",
    createNewFactory: "Unda Kiwanda Kipya",
    factoryName: "Jina la Kiwanda",
    factoryNumber: "Nambari ya Kiwanda",
    firstName: "Jina la Kwanza",
    lastName: "Jina la Mwisho",
    primaryEmailAddress: "Anwani ya Barua Pepe ya Msingi",
    submit: "Wasilisha",
    downloadTemplate: "Unduh Model",
    templateInfo: "Unduh file template untuk melihat format yang diperlukan untuk pendaftaran massal.",
    templateFormat: "Mohon berikan file dalam format CSV.",
    selectFileToUpload: "Pilih file untuk mengunggah data",
    uploadFileOrDragAndDrop: "atau seret dan letakkan di sini",
  },
};
